import { createModel } from "hox";
import { useSessionStorageState } from "ahooks";
import { Key, useEffect, useState } from "react";
import { ICustomerAccountSummary } from "../../../AccountTypes";
import { accountService } from "../../../AccountService";
import useNavModel from "../../../../../model/navModel";
import { IMdOrgDetail, orgService } from "../../../../base/org/orgService";
import { ITreeData } from "../../../../base/dict/dictModel";
import { dictService, IMdDictFields } from "../../../../base/dict/dictService";
import { OptionDsType } from "../../../../../types/FmsTypes";
import { useGlobalModel } from "@/model/globalModel";

export enum ActionTypeEnum {
    ACCOUNT,
    ADJUST_LIST,
    RECHARGE_LIST,
    TRANSFER_LIst,
    BILL_LIST,
    WRITEOFF_LIST,
    LOG_LIST,
    SYSTEM_RECEIVABLE,
    NULL
}

type labelsType = {
    [proppName: string]: string;
}

export const useDetailModel = createModel(function () {
    const { user: { shopCode }, resourceAuth } = useGlobalModel();
    const [supplierCode, setSupplierCode] = useSessionStorageState<string>("accountShop.detail.supplierCode", "");
    const [actionType, setActionType] = useSessionStorageState("supplierManage.detail.type", ActionTypeEnum.NULL) // 选中展示模块
    const [supplier, setSupplier] = useState<ICustomerAccountSummary>({ key: "" });
    const { closeNav } = useNavModel(() => []);

    const [orgDs, setOrgDs] = useState<ITreeData<IMdOrgDetail>[]>();
    const [beDs, setBeDs] = useState<OptionDsType[]>();
    const [appDs, setAppDs] = useState<OptionDsType[]>();
    const [payMethodDs, setPayMethodDs] = useState<ITreeData<IMdDictFields>[]>();
    const [payMethodLabels, setPayMethodLabels] = useState<labelsType>({});
    const [accountTypeDs, setAccountType] = useState<OptionDsType[]>([]);


    const loadSummaryData = (code?: Key) => {
        if (supplierCode) {
            accountService
                .supplierSummaryOne(supplierCode, shopCode)
                .then(({ retData }) => {
                    setSupplier(retData ?? {});
                });
        }
    }
    return {
        appDs,
        orgDs,
        beDs,
        payMethodDs,
        payMethodLabels,
        actionType,
        supplierCode,
        supplier,
        accountTypeDs, setAccountType,
        setActionType,
        setSupplierCode,
        loadSummaryData,
        setOrgDs,
        setBeDs,
        setPayMethodDs,
        setPayMethodLabels,
        setAppDs,
        closeNav,
    }
});
